import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";

import { useStyles } from "../../../../../Components/CSS/TableStyle.css";
import BookListBody from "../IssuedBookBody/IssuedBookBody";
import CustomTableHead from "../../../../../Components/Table/CustomTableHeader/CustomTableHeader";
import CustomTableFooter from "../../../../../Components/Table/CutomTableFooter/CustomTableFooter";
import AddIssuedBook from "../AddIssuedBook/AddIssuedBook";
import { connect } from "react-redux";
import IssuedBookFilter from "../IssuedBookFilter/IssuedBookFilter";

class ViewIssuedBook extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rowsPerPage: 5,
      page: 0,
      searchBy: {
        issuedDate: "",
      },
      column: [
        { name: "S.N" },
        { name: "Issued Date" },
        { name: "Due Date" },
        { name: "Return Date" },
        { name: "Student" },
        { name: "Actions" },
      ],
      issued: [],
      isEmpty: false,
    };
  }

  handleSearch = (e) => {
    this.setState({
      searchBy: {
        ...this.state.searchBy,
        [e.target.name]: e.target.value,
      },
    });
  };

  handlePage = (e, newPage) => {
    this.setState({
      page: newPage,
    });
  };

  handleRowsPerPage = (e) => {
    this.setState({
      rowsPerPage: +e.target.value,
      page: 0,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
  };

  render() {
    const { rowsPerPage, page } = this.state;
    const filtered = this.props.issuedData.filter((book) => {
      return book.issuedDate.indexOf(this.state.searchBy.issuedDate) !== -1;
    });
    return (
      <div>
        <IssuedBookFilter
          data={this.state.searchBy}
          handleSearch={this.handleSearch}
        />

        <TableContainer>
          <Table>
            <CustomTableHead column={this.state.column} />

            <TableBody>
              {this.props.bookDetails.currentStock < 0 ? (
                <TableRow>
                  <TableCell align="center">
                    You cannot issued any more book.
                  </TableCell>
                </TableRow>
              ) : (
                <AddIssuedBook
                  bookId={this.props.bookId}
                  getBookDetails={this.props.getBookDetails}
                />
              )}
              {filtered
                .slice(rowsPerPage * page, rowsPerPage * page + rowsPerPage)
                .map((issued, index) => (
                  <BookListBody
                    data={issued}
                    key={index}
                    index={index}
                    bookId={this.props.bookId}
                    getBookDetails={this.props.getBookDetails}
                  />
                ))}
            </TableBody>

            <CustomTableFooter
              count={filtered.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onChangePage={this.handlePage}
              onChangeRowsPerPage={this.handleRowsPerPage}
            />
          </Table>
        </TableContainer>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

export default connect(
  mapStateToProps,
  null
)(withStyles(useStyles)(withRouter(ViewIssuedBook)));
